module.exports = __webpack_public_path__ + "static/battle_smith-af7d1b6dcb03e0363870e618203f20f6.png";